import React from "react";

import LayoutMedior from "../../layouts/LayoutMedior";
import ProjectSubpage from "../../modules/ProjectSubpage";

const ProjectPage = () => {
  return (
    <div >
    <LayoutMedior>
      <ProjectSubpage ></ProjectSubpage>
    </LayoutMedior>
    </div>
  );
};

export default ProjectPage;
